import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import SearchField from "../../utils/SearchField";
import StaticFunctions from "../../utils/StaticFunctions";
import TableContainer from "../../utils/TableContainer";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import LanguageSelector from "../../globalComponents/LanguageSelector";
import CheckBoxField from "../../utils/CheckBoxField";
import InputField from "../../utils/InputField";

class TranslationOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    static defaultProps = {
        translations: null,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            comparison: null,
            translateTo: null,
            showOnlyMissingTranslations: false,
            searchStr: null,
            translations: null,
            filteredTranslations: null,
            inputParams: {}
        };

        this.translate = this.props.baseData.translate;

        this.requestLanguages = this.requestLanguages.bind(this);
        this.saveTranslation = this.saveTranslation.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.enterTranslate = this.enterTranslate.bind(this);
        this.onTranslate = this.onTranslate.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);
        this.getFilteredTranslations = this.getFilteredTranslations.bind(this);

    }

    requestLanguages() {

        const comparison = this.state.comparison;
        const translateTo = this.state.translateTo;
        const missingOnly = this.state.showOnlyMissingTranslations;

        if (comparison && translateTo) {
            const params = {
                action: 'getTranslationOverview',
                userId: this.props.baseData.userData.id,
                comparison: comparison.value,
                translateTo: translateTo.value,
                missingOnly: missingOnly
            };

            const callback = function (res) {
                if (res) {
                    this.setState({
                        translations: res
                    }, this.getFilteredTranslations);
                }
            }.bind(this);

            this.api.request('TranslationTool', params, callback, null);
        }

    }

    saveTranslation(key) {

        const translateTo = this.state.translateTo;
        const value = (key && this.state.inputParams[key]) ? this.state.inputParams[key] : null;

        if (key && translateTo && value) {
            const params = {
                action: 'saveTranslation',
                userId: this.props.baseData.userData.id,
                key: key,
                language: translateTo.value,
                value: value
            };

            const callback = function (res) {
                if (res) {
                    this.requestLanguages();
                }
            }.bind(this);

            this.api.request('TranslationTool', params, callback, null);
        }

    }

    saveTranslationSave(key) {

        const translateTo = this.state.translateTo;
        const value = (key && this.state.inputParams[key]) ? this.state.inputParams[key] : null;

        if (key && translateTo && value) {
            const params = {
                action: 'saveTranslation',
                key: key,
                language: translateTo.value,
                value: value,
                userId: this.props.baseData.userData.id,
            };

            const callback = function (res) {
                if (res) {
                    this.requestLanguages();

                    //if (res.success) alert(this.translate(res.msgKey));
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    onSearch(name, searchStr) {

        this.setState({
            searchStr: (searchStr !== '') ? searchStr : null
        }, this.getFilteredTranslations);

    }

    onCancel() {

        this.setState({
            filteredTranslations: this.state.translations,
        });

    }

    enterTranslate(event, key, value, isValid) {

        if (event && event.keyCode === 13) {
            this.onTranslate(event, key, value, isValid, this.saveTranslation);
        }

    }

    onTranslate(event, key, value, isValid, saveCallback = StaticFunctions.noOp) {

        if (key) {
            const newParams = {...this.state.inputParams};

            const oldValue = newParams[key];

            if (value !== oldValue) {
                newParams[key] = value;

                this.setState({
                    inputParams: newParams
                }, () => saveCallback(key));
            }

        }

    }

    onSelect(language, fieldName) {

        if (language && fieldName) {
            const newState = {...this.state};

            newState[fieldName] = language;

            this.setState(newState, this.requestLanguages);
        }

    }

    toggleCheckBox(fieldName, isChecked) {

        const state = {...this.state};

        state[fieldName] = isChecked;

        this.setState(state, this.requestLanguages);

        // Safe option to Userconfig
        if (this.props.saveSettings && isChecked !== null) {
            this.props.saveSettings(fieldName, isChecked);
        }

    }

    getFilteredTranslations() {

        const searchStr = this.state.searchStr;

        let filteredRows = [];

        if (searchStr) {
            const rows = (this.state.translations) ? this.state.translations : [];
            const searchFields = ['key', 'comparison', 'translateTo'];

            rows.forEach(
                (row) => {
                    let addToResult = false;

                    searchFields.forEach(
                        (searchField) => {
                            if (row[searchField] && StaticFunctions.substringExists(row[searchField], searchStr)) addToResult = true;
                        }
                    );

                    if (addToResult) filteredRows.push(row);
                }
            );
        } else {
            filteredRows = this.state.translations;
        }

        this.setState({
            filteredTranslations: filteredRows,
        });

    }

    getColumns() {

        if (!this.state.comparison || !this.state.translateTo) return [];

        return [
            {
                key: 'key',
                nameKey: 'key',
                sortType: 'children'
            },
            {
                key: 'comparison',
                name: this.state.comparison.label,
                sortType: 'children'
            },
            {
                key: 'translateTo',
                name: this.state.translateTo.label,
            },
            {
                key: 'options',
                nameKey: 'options',
            }
        ];

    }

    getRows() {

        const data = (this.state.filteredTranslations) ? this.state.filteredTranslations : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let addRow = {
                key: <span title={rowTemp.key}>{rowTemp.key}</span>,
                comparison: <span title={rowTemp.comparison}>{rowTemp.comparison}</span>,
                translateTo: <InputField id={rowTemp.key} key={rowTemp.key} name={rowTemp.key} value={rowTemp.translateTo} onKeyDown={this.enterTranslate} onBlur={this.onTranslate} />,
                options: <div className="tableOptions">
                    <a className="optionSave" onClick={() => this.saveTranslation(rowTemp.key)} title={this.translate('save')}>&nbsp;</a>
                </div>
            };

            rows.push(addRow);
        }

        return rows;

    }

    renderResult() {

        if (!this.state.comparison || !this.state.translateTo) return null;
        if (!this.state.translations) return <LoadingSplash color={'dark'} />;

        const dataCount = (this.state.filteredTranslations) ? this.state.filteredTranslations.length : 0;
        const countText = (dataCount === 1) ? this.translate('translation') : this.translate('translations');
        const columns = this.getColumns();
        const rows = this.getRows();

        return (
            <div>
                <div className="clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.state.comparison.title} -> {this.state.translateTo.title}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchTranslation"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{StaticFunctions.formatedNumber(dataCount)} {countText} {this.translate('found')}.</p>
                        </div>
                    </div>
                </div>

                <div className="clearfix">
                    <TableContainer
                        baseData={this.props.baseData}
                        tableClasses="nowrap"
                        columns={columns}
                        rows={rows}
                        maxHeight={690}
                    />
                </div>
            </div>
        );

    }

    render() {

        const renderedResult = this.renderResult();

        return (
            <div>
                <div className="clearfix">
                    <div className="col-sm-2">
                        <div className="ma-bo-20">
                            <h4>{this.translate('translateFrom')}</h4>

                            <div>
                                <LanguageSelector
                                    name="translateTo"
                                    baseData={this.props.baseData}
                                    onSelect={(e) => {this.onSelect(e, 'comparison')}}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-2">
                        <div className="ma-bo-20">
                            <h4>{this.translate('translateTo')}</h4>

                            <div>
                                <LanguageSelector
                                    name="comparison"
                                    baseData={this.props.baseData}
                                    onSelect={(e) => {this.onSelect(e, 'translateTo')}}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-2">
                        <div className="ma-bo-20">
                            <h4>{this.translate('optionen')}</h4>

                            <div className="formSettings">
                                <div className="formBox">
                                    <CheckBoxField
                                        name="showOnlyMissingTranslations"
                                        label={this.translate('showOnlyMissingTranslations')}
                                        isChecked={this.state.showSubThreadbreaks}
                                        onChange={this.toggleCheckBox}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="clearfix">
                    {renderedResult}
                </div>
            </div>
        );

    }

}

export default TranslationOverviewContainer;